// Export an array of topics for VA 1st Grade Math
const va2ndMathQuizContent = [
  {
    "slug": "placevalue",
    "title": "Place Value",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. What does place value tell us?",
        "answers": [
          { "text": "How much a digit is worth based on its place", "correct": true },
          { "text": "The color of the number", "correct": false },
          { "text": "The size of the number", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which place comes after the ones place?",
        "answers": [
          { "text": "Tens place", "correct": true },
          { "text": "Hundreds place", "correct": false },
          { "text": "Thousands place", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which place comes after the tens place?",
        "answers": [
          { "text": "Hundreds place", "correct": true },
          { "text": "Ones place", "correct": false },
          { "text": "Thousands place", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What happens when you move one place to the left?",
        "answers": [
          { "text": "The value becomes 10 times greater", "correct": true },
          { "text": "The value becomes smaller", "correct": false },
          { "text": "Nothing changes", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What comes after the hundreds place?",
        "answers": [
          { "text": "Thousands place", "correct": true },
          { "text": "Ones place", "correct": false },
          { "text": "Tens place", "correct": false }
        ]
      }
    ]
  },
  {
    "slug": "greaterthan",
    "title": "Greater Than",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. What does the alligator mouth face toward?",
        "answers": [
          { "text": "The larger number", "correct": true },
          { "text": "The smaller number", "correct": false },
          { "text": "The equal number", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which side is less than?",
        "answers": [
          { "text": "The closed side of the alligator", "correct": true },
          { "text": "The open side of the alligator", "correct": false },
          { "text": "The tail of the alligator", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What does the equal sign mean?",
        "answers": [
          { "text": "Both numbers are the same", "correct": true },
          { "text": "The first number is smaller", "correct": false },
          { "text": "The first number is larger", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which symbol shows 'greater than'?",
        "answers": [
          { "text": ">", "correct": true },
          { "text": "<", "correct": false },
          { "text": "=", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. If 8 > 5, what does this mean?",
        "answers": [
          { "text": "8 is greater than 5", "correct": true },
          { "text": "8 is less than 5", "correct": false },
          { "text": "8 is equal to 5", "correct": false }
        ]
      }
    ]
  },
  {
    "slug": "countby5s",
    "title": "Count By 5's",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. What number comes after 5 when counting by 5's?",
        "answers": [
          { "text": "10", "correct": true },
          { "text": "6", "correct": false },
          { "text": "15", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What number comes after 25 when counting by 5's?",
        "answers": [
          { "text": "30", "correct": true },
          { "text": "35", "correct": false },
          { "text": "20", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What number do you say after 50 when counting by 5's?",
        "answers": [
          { "text": "55", "correct": true },
          { "text": "60", "correct": false },
          { "text": "65", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which list shows numbers counted by 5's?",
        "answers": [
          { "text": "5, 10, 15, 20, 25", "correct": true },
          { "text": "2, 4, 6, 8, 10", "correct": false },
          { "text": "1, 3, 5, 7, 9", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What number comes before 100 when counting by 5's?",
        "answers": [
          { "text": "95", "correct": true },
          { "text": "90", "correct": false },
          { "text": "85", "correct": false }
        ]
      }
    ]
  },
  {
    "slug": "countby10s",
    "title": "Count By 10's",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. What number comes after 10 when counting by 10's?",
        "answers": [
          { "text": "20", "correct": true },
          { "text": "15", "correct": false },
          { "text": "25", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What number comes after 40 when counting by 10's?",
        "answers": [
          { "text": "50", "correct": true },
          { "text": "45", "correct": false },
          { "text": "60", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which list shows numbers counted by 10's?",
        "answers": [
          { "text": "10, 20, 30, 40, 50", "correct": true },
          { "text": "5, 10, 15, 20, 25", "correct": false },
          { "text": "2, 4, 6, 8, 10", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What number comes before 100 when counting by 10's?",
        "answers": [
          { "text": "90", "correct": true },
          { "text": "80", "correct": false },
          { "text": "70", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. How much does each number increase when you count by 10's?",
        "answers": [
          { "text": "10 more each time", "correct": true },
          { "text": "5 more each time", "correct": false },
          { "text": "2 more each time", "correct": false }
        ]
      }
    ]
  },
  {
    "slug": "ordinalnumbers",
    "title": "Ordinal Numbers",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. What position does 'first' represent?",
        "answers": [
          { "text": "1st", "correct": true },
          { "text": "2nd", "correct": false },
          { "text": "3rd", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. If you finish a race in 2nd place, what is your ordinal number?",
        "answers": [
          { "text": "Second", "correct": true },
          { "text": "Third", "correct": false },
          { "text": "First", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which ordinal number comes right after fifth?",
        "answers": [
          { "text": "Sixth", "correct": true },
          { "text": "Fourth", "correct": false },
          { "text": "Seventh", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. If the blue car finished 8th and the red car finished 9th, which car came first?",
        "answers": [
          { "text": "The blue car", "correct": true },
          { "text": "The red car", "correct": false },
          { "text": "They tied", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What is the ordinal number for the position after tenth?",
        "answers": [
          { "text": "Eleventh", "correct": true },
          { "text": "Ninth", "correct": false },
          { "text": "Twelfth", "correct": false }
        ]
      }
    ]
  },
  {
    "slug": "dollarscents",
    "title": "Dollars & Cents",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. How many cents are in one dollar?",
        "answers": [
          { "text": "100", "correct": true },
          { "text": "50", "correct": false },
          { "text": "25", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. How much is a nickel worth?",
        "answers": [
          { "text": "5 cents", "correct": true },
          { "text": "10 cents", "correct": false },
          { "text": "1 cent", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which president is on the penny?",
        "answers": [
          { "text": "Abraham Lincoln", "correct": true },
          { "text": "George Washington", "correct": false },
          { "text": "Thomas Jefferson", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. If you have 4 quarters, how much money do you have?",
        "answers": [
          { "text": "$1.00", "correct": true },
          { "text": "$0.50", "correct": false },
          { "text": "$0.75", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. How many dimes make one dollar?",
        "answers": [
          { "text": "10", "correct": true },
          { "text": "4", "correct": false },
          { "text": "5", "correct": false }
        ]
      }
    ]
  },

  {
  "slug": "englishruler",
  "title": "English Ruler",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. How many inches are in one foot?",
      "answers": [
        { "text": "12", "correct": true },
        { "text": "10", "correct": false },
        { "text": "16", "correct": false }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. On a ruler, what does each number represent?",
      "answers": [
        { "text": "One inch", "correct": true },
        { "text": "One foot", "correct": false },
        { "text": "One centimeter", "correct": false }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What is the notch halfway between two inches called?",
      "answers": [
        { "text": "1/2 inch", "correct": true },
        { "text": "1/4 inch", "correct": false },
        { "text": "1/8 inch", "correct": false }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Which notch is smaller than 1/4 inch but larger than 1/16 inch?",
      "answers": [
        { "text": "1/8 inch", "correct": true },
        { "text": "1/2 inch", "correct": false },
        { "text": "1 inch", "correct": false }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What is the smallest marking on a ruler usually called?",
      "answers": [
        { "text": "1/16 inch", "correct": true },
        { "text": "1/8 inch", "correct": false },
        { "text": "1/2 inch", "correct": false }
      ]
    }
  ]
},
{
  "slug": "tellingtime",
  "title": "Telling Time",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. What does the little hand on a clock show?",
      "answers": [
        { "text": "The hour", "correct": true },
        { "text": "The minutes", "correct": false },
        { "text": "The seconds", "correct": false }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What does the big hand on a clock show?",
      "answers": [
        { "text": "The minutes", "correct": true },
        { "text": "The hours", "correct": false },
        { "text": "The days", "correct": false }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. When the big hand points to the 3, how many minutes have passed?",
      "answers": [
        { "text": "15 minutes", "correct": true },
        { "text": "10 minutes", "correct": false },
        { "text": "20 minutes", "correct": false }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. When the little hand points to the 4, what time is it?",
      "answers": [
        { "text": "4 o’clock", "correct": true },
        { "text": "3 o’clock", "correct": false },
        { "text": "5 o’clock", "correct": false }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. How many minutes are between each number on a clock?",
      "answers": [
        { "text": "5 minutes", "correct": true },
        { "text": "10 minutes", "correct": false },
        { "text": "1 minute", "correct": false }
      ]
    }
  ]
},
{
  "slug": "shapes",
  "title": "Shapes",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. How many sides does a triangle have?",
      "answers": [
        { "text": "3", "correct": true },
        { "text": "4", "correct": false },
        { "text": "5", "correct": false }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. How many sides does a rectangle have?",
      "answers": [
        { "text": "4", "correct": true },
        { "text": "3", "correct": false },
        { "text": "5", "correct": false }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. How many sides does a square have?",
      "answers": [
        { "text": "4", "correct": true },
        { "text": "6", "correct": false },
        { "text": "8", "correct": false }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. How many sides does a pentagon have?",
      "answers": [
        { "text": "5", "correct": true },
        { "text": "4", "correct": false },
        { "text": "6", "correct": false }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. How many sides does an octagon have?",
      "answers": [
        { "text": "8", "correct": true },
        { "text": "6", "correct": false },
        { "text": "5", "correct": false }
      ]
    }
  ]
},
{
  "slug": "quadrilaterals",
  "title": "Quadrilaterals",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. How many sides does a quadrilateral have?",
      "answers": [
        { "text": "4", "correct": true },
        { "text": "3", "correct": false },
        { "text": "5", "correct": false }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What kind of angles does a rectangle have?",
      "answers": [
        { "text": "Four right angles", "correct": true },
        { "text": "Three equal angles", "correct": false },
        { "text": "Two right angles", "correct": false }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. In a square, all sides are:",
      "answers": [
        { "text": "Equal in length", "correct": true },
        { "text": "Different lengths", "correct": false },
        { "text": "Curved", "correct": false }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. A parallelogram has:",
      "answers": [
        { "text": "Two pairs of parallel sides", "correct": true },
        { "text": "Four right angles", "correct": false },
        { "text": "Three equal sides", "correct": false }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Which of these is NOT a quadrilateral?",
      "answers": [
        { "text": "Triangle", "correct": true },
        { "text": "Square", "correct": false },
        { "text": "Rectangle", "correct": false }
      ]
    }
  ]
},
{
  "slug": "pictograph",
  "title": "Pictograph",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. What does a pictograph use to show information?",
      "answers": [
        { "text": "Pictures or symbols", "correct": true },
        { "text": "Numbers only", "correct": false },
        { "text": "Words only", "correct": false }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What tells us what each picture stands for in a pictograph?",
      "answers": [
        { "text": "The key", "correct": true },
        { "text": "The title", "correct": false },
        { "text": "The legend", "correct": false }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. If one picture equals 5 apples, how many apples do 3 pictures show?",
      "answers": [
        { "text": "15 apples", "correct": true },
        { "text": "10 apples", "correct": false },
        { "text": "5 apples", "correct": false }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. A pictograph is useful because it helps us:",
      "answers": [
        { "text": "See data clearly using pictures", "correct": true },
        { "text": "Write long paragraphs", "correct": false },
        { "text": "Measure length in inches", "correct": false }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Which of the following would most likely be shown with a pictograph?",
      "answers": [
        { "text": "Number of pets in each class", "correct": true },
        { "text": "Steps in a recipe", "correct": false },
        { "text": "Temperature changes", "correct": false }
      ]
    }
  ]
}, 
]

export default va2ndMathQuizContent;
